 

// @ts-nocheck
import React, { useState } from 'react';
import AbsenceTab from './Absence/AbsenceTab.js';
import VacationBalance from './VacationBalance/VacationBalance.js';
import { useParams } from 'react-router-dom';
import { Card, CardBody } from '@components/card/card.jsx';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Breadcrumb from '@components/Shared/Breadcrumb';
import { Nav } from 'react-bootstrap';

const Index = () => {
  const { personId } = useParams();
  const { AbsenceAttendanceList: data } = useSelector(state => state.Absence);
  const { i18n, t } = useTranslation();
  const [activeTab, setActiveTab] = useState('absence');

  const BreadcrumbList = [
    {
      name: 'الرئيسية',
      link: ':moduleHome'
    },
    {
      name: 'الموظفين',
      link: '/HR/Employees'
    },
    {
      name: 'الغياب والإجازات',
      link: null
    }
  ];

  return (
    <div>
      <Breadcrumb
        BreadcrumbList={BreadcrumbList}
        PageName='الغياب والإجازات'
        // subtitle={i18n.language === 'ar' ? data?.name2 : data?.name}
      />

      {/* كرت التبويبات واسم الموظف */}
      <Card className=' mb-4'>
        <CardBody className='p-0'>
          {/* رأس الكرت - اسم الموظف */}
          <div className='p-3 border-bottom'>
            <div className='d-flex align-items-center justify-content-between'>
              <div>
                <h5 className='mb-1'>
                  <i className='fa fa-user me-2 text-theme'></i>
                  {i18n.language === 'ar' ? data?.name2 : data?.name}
                </h5>
                <small className='text-muted'>رقم الموظف: {'000'}</small>
              </div>
            </div>
          </div>

          {/* التبويبات */}
          <div className='p-3'>
            <Nav variant='tabs' className='nav-tabs-simple'>
              <Nav.Item>
                <Nav.Link
                  active={activeTab === 'absence'}
                  onClick={() => setActiveTab('absence')}
                  className='fw-medium px-5'
                >
                  <i className='fa fa-calendar-times me-2'></i>
                  الإجازات
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link
                  active={activeTab === 'vacation'}
                  onClick={() => setActiveTab('vacation')}
                  className='fw-medium px-5'
                >
                  <i className='fa fa-umbrella-beach me-2'></i>
                  رصيــد الإجازات
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </div>
        </CardBody>
      </Card>

      {/* محتوى التبويبات */}
      {activeTab === 'absence' && <AbsenceTab personId={personId} />}

      {activeTab === 'vacation' && <VacationBalance personId={personId} />}
    </div>
  );
};

export default Index;
